<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  render(createElement, context) {
    const { icon, title } = context.props;
    const vnodes = [];

    if (icon) {
      if (icon.includes("el-icon")) {
        const elHtml = createElement("i", {
          attrs: {
            class: icon,
          },
        });
        vnodes.push(elHtml);
      } else {
        // const elHtml = createElement("svg-icon", {
        //   attrs: {
        //     "icon-class": icon,
        //   },
        // });
        const elHtml = createElement("i", {
          attrs: {
            class: [icon],
            style:"margin: 15px 10px 15px 15px;font-size: 18px;color: #5D8C82;"
          },
        });
        vnodes.push(elHtml);
      }
    }

    if (title) {
      const elHtml=createElement(
        "div",
        {
          attrs: {
            slot: "title",
            style:"  font-size: 16px;height: 48px;line-height: 48px !important;display: inline-block; vertical-align:middle;"
          },
        },
        title
      );
      vnodes.push(elHtml);
    }
    return vnodes;
  },
};
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em ;
}
.el-menu-item{
  margin: 0 10px 10px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Item.vue